import {
  defineNuxtRouteMiddleware,
  navigateTo,
  useCookie,
  useNuxtApp,
  useRequestURL,
  useRequestHeaders,
  useState
} from "nuxt/app";
import { getMainDomain, isAccountEnabled } from "../utils/DomainUtils.js";
import { OIDC_SILENT_ERROR_CODES as knownErrors } from "../config/oidc.js";
import usePip from "../composables/usePip.js";
export default defineNuxtRouteMiddleware(async (to, from) => {
  const { setIsAuth, setUserinfo } = usePip();
  try {
    if (true) return;
    const mainDomain = getMainDomain(useRequestURL().host);
    const dpgComponentAtCookie = useCookie("dpg-component-at");
    const dpgComponentUitCookie = useCookie("dpg-component-uit");
    const isRedirectedCookie = useCookie("tapp-pip-redirected", {
      maxAge: 60 * 5
      // 5 minutes
    });
    if (!isAccountEnabled(mainDomain)) {
      useState("isPipDisabled", () => true);
      return;
    }
    if (!dpgComponentAtCookie.value) return;
    if (from.query.error) {
      if ([knownErrors.login_required, knownErrors.interaction_required].some((el) => el === from.query.error)) return;
      useNuxtApp().$logger.log({
        title: from.query.error.toString(),
        metadata: {
          query: from.query
        }
      });
      return;
    }
    const { verify } = await import("../utils/JwtUtils.js");
    const verifiedAT = await verify(dpgComponentAtCookie.value);
    const verifiedUIT = await verify(dpgComponentUitCookie.value || "");
    if (verifiedAT && verifiedUIT) {
      setIsAuth(true);
      setUserinfo(verifiedUIT);
      isRedirectedCookie.value = "";
    } else {
      if (isRedirectedCookie.value) return;
      isRedirectedCookie.value = "1";
      const encodedCallbackUrl = encodeURIComponent(useRequestURL().href);
      navigateTo(`https://account.${mainDomain}/login?prompt=none&callback_url=${encodedCallbackUrl}`, {
        external: true
      });
    }
  } catch (error) {
    console.log({ error });
    useNuxtApp().$logger.log({
      title: "Token validation failed",
      error,
      metadata: {
        headers: useRequestHeaders()
      }
    });
  }
});
